import { render, staticRenderFns } from "./counter.vue?vue&type=template&id=addf99c0&scoped=true&"
import script from "./counter.vue?vue&type=script&lang=js&"
export * from "./counter.vue?vue&type=script&lang=js&"
import style0 from "./counter.vue?vue&type=style&index=0&id=addf99c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addf99c0",
  null
  
)

export default component.exports